import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UserStore } from '../stores/user.store';
import { Router } from '@angular/router';
import { lastValueFrom, Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private userStore = inject(UserStore);

  async initAuthSteps() {
    // set accessToken and fetch profile data for user
    return await lastValueFrom(this.getMe());
  }

  logout(redirect = true) {
    this.userStore.clearAuth();
    this.http.post(`${environment.apiUrl}/oauth/logout`, {}).subscribe({
      next: () => {
        if (redirect) {
          this.router.navigate(['/auth/sign-in']);
        }
      },
    });
  }

  login(): Observable<void> {
    return this.http.get(`${environment.apiUrl}/oauth/login`).pipe(
      tap((response: any) => {
        window.location.href = response;
      }),
    );
  }

  getMe() {
    return this.http
      .get(`${environment.apiUrl}/me`, { withCredentials: true })
      .pipe(
        tap((response: any) => {
          this.userStore.setUser(response.user);
        }),
      );
  }
}
